<template>
<v-card tile>
  
    <v-app-bar
      :light="!darkTheme"
      :dark="darkTheme"
      extended
      extension-height="100"
      elevate-on-scroll
      color="rgba(255,255,255,1.0)"
      app
    >
    <v-row class="px-6 logo-color" v-if="$vuetify.breakpoint.xs"  @click="goToPage('/')">
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="4" contain></v-img>
    </v-row>


<v-row>
  <v-col cols="2">
    <div v-if="pathHome && $vuetify.breakpoint.xs" class="empty-right"></div>
      <v-app-bar-nav-icon v-if="!pathHome && $vuetify.breakpoint.xs" @click.stop="drawer = !drawer" class="mr-0  burger-mob-bg"> Меню </v-app-bar-nav-icon>
    <div class="pa-1 logo-w " v-if="$vuetify.breakpoint.smAndUp" @click="goToPage('/')">
      <v-img src="../assets/logo-gagarin.png" position="top left" aspect-ratio="4.5" contain v-if="!drawer && darkTheme" transition="slide-x-transition" reverse-transition="slide-x-reverse-transition"></v-img>
      <v-img src="../assets/logo-gagarin.svg" position="top left" aspect-ratio="4.5" contain v-if="!drawer && !darkTheme" transition="slide-x-transition" reverse-transition="slide-x-reverse-transition"></v-img>
    </div>  
  </v-col>
  <v-col cols="8">

<div></div>


  </v-col>
  <v-col cols="2" class="px-0">
<div v-if="$vuetify.breakpoint.mdAndUp" class="text-left">
<div>
  <v-icon>mdi-clock</v-icon>
      <v-btn small text>
        часы работы: 9:00 - 22:00
      </v-btn>
</div>
<div>
  <v-icon>mdi-map-marker</v-icon>
      <v-btn small text @click="goToPage('/'+loadPathData.mnuContactsPath)" class="topmnu-btn">
        контакты: ул. Вавилова, 3
      </v-btn>
</div>
</div>
  </v-col>
</v-row>

      <template v-slot:extension >  
        <v-row justify="space-between" align="center" class="pt-0 ma-0">
          <v-col cols="2"  class="pa-0 d-flex align-start">
            <v-btn icon v-if="!pathHome && $vuetify.breakpoint.xs" @click="backPath">
            {{$router.path}}
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-app-bar-nav-icon v-if="pathHome  && $vuetify.breakpoint.xs" @click.stop="drawer = !drawer" class="burger-mob-bg"></v-app-bar-nav-icon> 
            <v-app-bar-nav-icon v-if="pathHome &&  $vuetify.breakpoint.smAndUp" @click.stop="drawer = !drawer" class="hmt3 burger-mob-bg"></v-app-bar-nav-icon> 

              </v-col>
              <v-col cols="8" class="pa-0">
                <v-row justify="center">
                  <v-col>
                    <TopFullMenu v-if="pathHome && $vuetify.breakpoint.smAndUp"/>
                  </v-col>
                </v-row>                
              </v-col>          
        </v-row>      

      </template>
    </v-app-bar>

    <v-navigation-drawer
      fixed
      v-model="drawer"
      temporary
      hide-overlay
      left
      app
      width="300"
      color="rgba(0,0,0,0.6)"
      dark
    >
    <div class="px-5 pt-3">
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="5.5" contain></v-img>
    </div>
    
    <v-divider></v-divider>
      <v-list dense >
        <span :key="`mnu-`+i" v-for="(itm, i) in drawerMenu">
                <v-list-item link  @click='goToPage(itm.url)'>
                  <v-list-item-content>
                    <v-list-item class="text-left title">{{itm.title}}</v-list-item>
                  </v-list-item-content>
                </v-list-item>

        </span>
      </v-list>

    </v-navigation-drawer>
</v-card>
</template>





<script>
import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import TopFullMenu from '@/components/TopFullMenu'
Vue.use(Vuex)



export default {
  name: 'AppBar',
  components: {
    TopFullMenu
  },  
  data () {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      mShops: [],
      admins: [
        ['Management', 'mdi-people'],
        ['Settings', 'mdi-settings']
      ],
      cruds: [
        ['Create', 'mdi-add'],
        ['Read', 'mdi-file'],
        ['Update', 'mdi-update'],
        ['Delete', 'mdi-delete']
      ],
      drawerMenu2: []
    }
  },
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    darkTheme: {
      get () {
        return this.$store.state.app.darkTheme
      },
      set (value) {
        this.$store.dispatch('setTheme', value)
      }
    },    
    pathHome(){
          return this.$route.path === '/'
      },
    drawer: {
      get () {
        return this.$store.state.menu.drawer
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateDrawer', val)
      }
    },
    drawerMenu: {
      get () {
        return this.$store.state.menu.menu
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateMenu', val)
      }
    },
      loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        }, 
    categories: {
      get () {
        if(DEBUG) console.log('this.$store.state.category :', this.$store.state.category.categories);
        return this.$store.state.category.categories
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateCategory', val)
      }
    }
  },
  methods: {
    goToPage (url) {
      this.$router.push(url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    },
    backPath() {
      this.$router.go(-1);
    },
  },
    mounted () {    
    
    let vApp = this;
    if(DEBUG) console.log('mounted Home = ', vApp)
    this.$nextTick(function () {
      
      if(DEBUG) console.log('this.$store AppBar :', vApp.$store)

    
    })
  }

}
</script>

<style  scoped>
  .logo-g{
  width: 100%;
  padding: 5px 10px;
}
.link-logo{
  margin: 1px 2px 3px 4px;
  width: 10%;
  background: url('../assets/logo-gagarin-w.svg') no-repeat center;
  background-size: 95% ;
  background-color: transparent;
}

.expan-panel-accord{
  background-color: #3339;
}
.expan-panel{
  background-color: transparent;
}
.theme--dark.v-expansion-panels .v-expansion-panel,
.list-itm
{
  background-color: transparent;
}
.empty-right{
 
  width: 48px;
}
.logo-w{

width:  250px;
cursor: pointer;

}
.hmt3{
  cursor: pointer;
}
.burger-mob-bg{
background-color: #33333399;
  border-radius: 2px;
}
</style>
